// add_to_cart event tracking for GA4 via dataLayer (GTM-PJ6SRR9N)
// Intercepts /cart/add.js (and .json) responses; on success, pushes add_to_cart event.
// Self-contained, no theme template changes — placed via theme.liquid include.

(function () {
  if (window.__atcTrackingInstalled) return;
  window.__atcTrackingInstalled = true;
  window.dataLayer = window.dataLayer || [];

  function asNum(x) { var n = parseFloat(x); return isNaN(n) ? 0 : n; }

  function pushAtc(payload) {
    try {
      var items = [];
      var totalValue = 0;
      var currency = (payload && payload.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';

      // /cart/add.js can return 1 item (object with id,product_id,variant_id...)
      // or {items: [...]}. Normalize:
      var entries = payload && payload.items ? payload.items : (payload ? [payload] : []);
      entries.forEach(function (it) {
        var price = asNum(it.final_price || it.price) / 100; // Shopify returns cents
        var qty = it.quantity || 1;
        totalValue += price * qty;
        items.push({
          item_id: String(it.product_id || it.id),
          item_name: it.product_title || it.title || '',
          item_variant: it.variant_title || it.variant_options?.join(' / ') || '',
          item_brand: it.vendor || 'Echipmunk',
          item_category: it.product_type || '',
          price: price,
          quantity: qty
        });
      });

      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: currency,
          value: totalValue,
          items: items
        }
      });
    } catch (e) { /* swallow */ }
  }

  // Patch fetch
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      var isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(urlStr);
      var p = origFetch.apply(this, arguments);
      if (isAdd) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(pushAtc).catch(function(){});
        }).catch(function(){});
      }
      return p;
    };
  }

  // Patch XMLHttpRequest (legacy themes)
  var XO = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var XS = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  if (XO && XS) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__atc_url = url || '';
      return XO.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      var self = this;
      this.addEventListener('load', function () {
        if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(self.__atc_url || '') && self.status >= 200 && self.status < 300) {
          try { pushAtc(JSON.parse(self.responseText)); } catch (e) {}
        }
      });
      return XS.apply(this, arguments);
    };
  }
})();
